import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { CONFIG } from '../../../config';
import { Box, Typography, CircularProgress, Alert, Stack } from '@mui/material';

// Import case details form component
import CaseDetailsForm from './components/CaseDetailsForm';

const API_HOST = CONFIG.modules['crm'].host;

const CaseDetailsMotherId = () => {
  const params = useParams();

  // State variables
  const [caseDetails, setCaseDetails] = useState(null);
  const [fetchingCaseDetails, setFetchingCaseDetails] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Network method to fetch case details
   */
  const fetchCaseDetails = async () => {
    try {
      setFetchingCaseDetails(true);
      const response = await axios.get(`${API_HOST}/case/${params.motherID}`);
      setCaseDetails(response.data.case);
      setError(null);
    } catch (error) {
      console.error('Error fetching case details:', error);
      setError('Failed to load case details. Please try again later.');
    } finally {
      setFetchingCaseDetails(false);
    }
  };

  /**
   * Update case Data with new values
   * Right now data should be updated in segments
   * @param {any} updatedData 
   */
  const updateCaseData = (updatedData) => {
    setCaseDetails(prev => ({
      ...prev,
      ...updatedData
    }))
  }

  // Fetch case details on component mount
  useEffect(() => {
    fetchCaseDetails();
  }, [params.motherID]);

  return (
    <Stack
      sx={{
        p: 3,
        minHeight: '100%',
      }}
      direction={"column"}
      spacing={2}
      flex={1} >

      {/* Error message */}
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {/* Loading state */}
      {fetchingCaseDetails ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        // Case details form
        caseDetails ? (
          <CaseDetailsForm
            caseData={caseDetails}
            updateCaseData={updateCaseData}
          // onSubmit={handleSubmit}
          // isSubmitting={submitting}
          />
        ) : (
          <Alert severity="warning">
            No case details found for Mother ID: {params.motherID}
          </Alert>
        )
      )}
    </Stack>
  );
};

export default CaseDetailsMotherId;
